import { Set } from 'immutable';

/**
 * @param {Node} node
 * @return {Set<Marks>} All the marks in the node
 */
export const getMarks = (node) => {
  const texts = node.getTexts();

  const marks = texts.reduce(
    (all, text) => {
      return text.characters.reduce(
        (accu, chars) => accu.union(chars.marks),
        all
      );
    },
    new Set()
  );

  return marks;
};



// WEBPACK FOOTER //
// ./src/components/slate/utils/getMarks.js